import {ReceiptItem} from "@app/shared/classes/receipt";
import {ApprovalStatusType, CurrentTxnStatus, ReturnItem, Transaction} from "@app/shared";

export class InvoiceSummary {

  vendorOrCustomerId: number;
  businessName: string;

  invoiceDate?: string;
  invoiceId?: number;
  invoiceNumber?: string;
  vendorInvoiceNumber: string;
  dueDate?: string;
  invoiceAmountDue: number;
  totalPayment: number;
  earlyPaymentDiscountAmount: number;
  pastDueInterestAmount: number;
  cashPurchase: boolean;
  balanceDue: number;           // FixMe - not coming from the backend
  balanceAmount: number;
  originalBalanceAmount: number;
  interestAccrued: number;
  applyDiscount: boolean;
  applyInterest: boolean;
  showDiscountCheckBox: boolean;
  showInterestCheckBox: boolean;
  isInterestorDiscoutWaivedOff: boolean;

  currentStatus: ApprovalStatusType;
  currentTxnStatus?: CurrentTxnStatus;
  hasSubmissionError: boolean;

  orderId: number;
  orderNumber: string;
  orderRevision: number;

  referenceNumber: string;

  receiptOrPckSlpId: number;
  receiptOrPckSlpNumber: string;
  receiptItems: ReceiptItem[];
  numberOfReceipts: number;

  returnId: number;
  returnNumber: string;
  returnAmount: number;
  returnItems: ReturnItem[];     // FixMe - should be PurchaseReturnItem type
  numberOfReturns: number;
  creditApplied: number;
  currentAmountDue: number;

  transaction: Transaction;

}

export class MatchItem {
  invoice: string;
  po: string;
  receipt: string;

  constructor(invoice: string, po: string, receipt: string) {
    this.invoice = invoice;
    this.po = po;
    this.receipt = receipt;
  }
}
